import { render } from "./header.vue?vue&type=template&id=984eb5d2&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=984eb5d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-984eb5d2"

export default script